import type { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import { IconButton } from '@breezeventures/ui-kit/icon-button';
import { Icon } from '@breezeventures/ui-kit/next/icon';
import { Typography } from '@breezeventures/ui-kit/typography';
import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';

type Props = ReactDatePickerCustomHeaderProps & {
  withNavigation?: boolean;
};

export const CustomHeader = ({
  monthDate,
  withNavigation = false,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: Props) => {
  return (
    <div className="flex items-center gap-2 px-2 py-3">
      {withNavigation && (
        <IconButton
          type="button"
          variant="ghost"
          size="s"
          aria-label="Previous month"
          disabled={prevMonthButtonDisabled}
          onClick={decreaseMonth}
        >
          <Icon
            name="chevron-down"
            size={24}
            version="v1"
            className="rotate-90"
            color="var(--color-primitive-primary)"
          />
        </IconButton>
      )}

      <Typography.Text
        tag="span"
        size="m"
        weight="medium"
        className="grow text-center"
      >
        {format(monthDate, 'LLLL', { locale: enUS })}
      </Typography.Text>

      {withNavigation && (
        <IconButton
          type="button"
          variant="ghost"
          size="s"
          aria-label="Next month"
          disabled={nextMonthButtonDisabled}
          onClick={increaseMonth}
        >
          <Icon
            name="chevron-down"
            size={24}
            version="v1"
            className={`-rotate-90`}
            color="var(--color-primitive-primary)"
          />
        </IconButton>
      )}
    </div>
  );
};
